import { render, staticRenderFns } from "./CuentasPendientes.vue?vue&type=template&id=8640e508&scoped=true"
import script from "./CuentasPendientes.vue?vue&type=script&lang=js"
export * from "./CuentasPendientes.vue?vue&type=script&lang=js"
import style0 from "./CuentasPendientes.vue?vue&type=style&index=0&id=8640e508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640e508",
  null
  
)

export default component.exports